/**
 * Handles common escaped characters that may not render properly in react and returns a literal string
 *
 * @param {character} string - the escaped character
 * @returns {escapedCharacter} Returns - literal react-compatible string
 */
export default function handleEscapedCharacters(character) {
    switch (character) {
        case '&amp;':
            return '&';
        case '&#39;':
            return "'";
        case '&quot;':
            return '"';
        case '&lt;':
            return '<';
        case '&gt;':
            return '>';
        default: // returns the string as is
            return character;
    }
}
